<template >
  <div>
    <van-collapse v-model="activeNames" accordion>
      <div v-for="(express, index) in orderExpressData" :key="express.id">
        <van-collapse-item :title="express.expressCompany + ' ' + express.expressNumber" :name="index" @click.native="expressTraceClick(express)">
          <div v-if="expressInfoData.length !== 0">
            <van-steps direction="vertical" :active="stepActive" active-color="#fea812" style="font-size: 14px;">
              <van-step v-for="(trace, index) in expressInfoData" :key="index">
                <div style="font-size: 14px;">{{trace.expressContext}}</div>
                <div style="line-height: 26px;">{{trace.expressTime}}</div>
              </van-step>
            </van-steps>
          </div>
          <div v-else>
            <span>{{generateCustomizeString('noExpressInfo')}}</span>
          </div>
        </van-collapse-item>
      </div>
    </van-collapse>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, Button, Cell, CellGroup, Tag, List, Collapse, CollapseItem, Step, Steps } from 'vant'
import request from '@/utils/request'

export default {
  name: 'ExpressInfo',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [List.name]: List,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Step.name]: Step,
    [Steps.name]: Steps
  },
  data() {
    return {
      stepActive: 0,
      activeNames: null,
      expressInfoData: []
    }
  },
  props: {
    orderExpressData: {
      type: Array,
      default: () => ([])
    }
    // expressInfoData: {
    //   type: Array,
    //   default: []
    // }
  },
  methods: {
    generateCustomizeString,
    expressTraceClick(express) {
      // this.expressCompany = row.expressCompany
      // this.expressNumber = row.expressNumber
      this.expressInfoData = []
      request({
        url: '/express/trace/detail',
        method: 'get',
        params: {
          express_number: express.expressNumber,
          express_company_id: express.expressCompanyId
        }
      })
        .then(response => {
          const expressInfo = []
          if (response.data.trades.length > 0) {
            for (var i = 0; i < response.data.trades.length; i++) {
              var obj = {}
              obj.expressTime = response.data.trades[i].time
              obj.expressContext = response.data.trades[i].context

              expressInfo[i] = obj
            }
          }
          this.expressInfoData = expressInfo.reverse()
          console.log(this.expressInfoData)
        })
        .catch(error => {
          console.warn(error)
        })
    }
  },
  created: function() {
    // Add barcode scan listener and pass the callback function
    // this.RegisterWxJsApi()
  }
}
</script>

<style lang="less" scoped>
</style>
